function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from 'axios';
import moment from 'moment';
export default {
  props: {
    url: String
  },
  data: function data() {
    return {
      newsItems: null,
      sub: 'http://feeds.feedburner.com/ac/NxOi?format=xml',
      dummy: '/assets/json/dummy.xml'
    };
  },
  mounted: function mounted() {
    this.loadFnc();
  },
  methods: {
    yearFnc: function yearFnc(e) {
      return moment(e).format('YYYY.');
    },
    dayFnc: function dayFnc(e) {
      return moment(e).format('MM.DD');
    },
    loadFnc: function () {
      var _loadFnc = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var xmlItem, parser, obj, items, array, num, i, title, link, pubDate;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios.get(this.url);

              case 3:
                xmlItem = _context.sent;
                parser = new DOMParser();
                obj = parser.parseFromString(xmlItem.data, 'text/xml');
                items = obj.getElementsByTagName('item');
                array = [];
                num = items.length > 4 ? 4 : items.length;

                for (i = 0; i < num; i++) {
                  title = items[i].getElementsByTagName('title')[0].textContent;
                  link = items[i].getElementsByTagName('link')[0].textContent;
                  pubDate = moment(items[i].getElementsByTagName('pubDate')[0].textContent).format('YYYY-MM-DD');
                  array = [].concat(_toConsumableArray(array), [{
                    'title': title,
                    'link': link,
                    'pubDate': pubDate
                  }]);
                }

                this.newsItems = array;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", false);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function loadFnc() {
        return _loadFnc.apply(this, arguments);
      }

      return loadFnc;
    }()
  }
};